import { ValidatorFn } from '@angular/forms';
import { Option } from '../../../../../classes';

export function optionNumberMinValidator (option:Option):ValidatorFn {
    return (): { [key: string]: boolean } => {
        if (option.question.options.filter(o=>o.type === 'number' && o.text).length === 0 && option.priority === 0) {
            return {
              not_enough_options:true,
            }
        }
        return null;
    }    
}
